import script from "./TransactionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionsPage.vue?vue&type=style&index=0&id=94fb7920&scoped=true&lang=css"
import "./TransactionsPage.vue?vue&type=style&index=1&id=94fb7920&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94fb7920"]])

export default __exports__